/* tslint:disable */
/* eslint-disable */
/**
 * Analytics Test
 * test for applicants to analytics team
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MultipleChoiceAnswerUpdatePayloadRequest
 */
export interface MultipleChoiceAnswerUpdatePayloadRequest {
    /**
     * 
     * @type {string}
     * @memberof MultipleChoiceAnswerUpdatePayloadRequest
     */
    text: string;
    /**
     * 
     * @type {boolean}
     * @memberof MultipleChoiceAnswerUpdatePayloadRequest
     */
    correct: boolean;
    /**
     * 
     * @type {number}
     * @memberof MultipleChoiceAnswerUpdatePayloadRequest
     */
    question: number;
}

/**
 * Check if a given object implements the MultipleChoiceAnswerUpdatePayloadRequest interface.
 */
export function instanceOfMultipleChoiceAnswerUpdatePayloadRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "text" in value;
    isInstance = isInstance && "correct" in value;
    isInstance = isInstance && "question" in value;

    return isInstance;
}

export function MultipleChoiceAnswerUpdatePayloadRequestFromJSON(json: any): MultipleChoiceAnswerUpdatePayloadRequest {
    return MultipleChoiceAnswerUpdatePayloadRequestFromJSONTyped(json, false);
}

export function MultipleChoiceAnswerUpdatePayloadRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MultipleChoiceAnswerUpdatePayloadRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'text': json['text'],
        'correct': json['correct'],
        'question': json['question'],
    };
}

export function MultipleChoiceAnswerUpdatePayloadRequestToJSON(value?: MultipleChoiceAnswerUpdatePayloadRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'text': value.text,
        'correct': value.correct,
        'question': value.question,
    };
}

